import React, { useEffect, useState }  from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Icon } from "semantic-ui-react";

import InfiniteScroll from "components/ui/InfiniteScroll";
import { fetchAccountIntegrations } from "actions/accounts";

import cx from "classnames";
import styles from "./integrations.module.scss";

export default function Integrations() {
	const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);

  const id = useSelector((state) => _.get(state, "accounts.account.id"));
  const integratedAccounts = useSelector((state) => _.get(state, "accounts.integration.items"));
  const isIntegrationsLoading = useSelector((state) => _.get(state, "accounts.integration.loading"))

  const currentPage = useSelector((state) => _.get(state, "accounts.integration.pagination.currentPage"));
  const totalPages = useSelector((state) => _.get(state, "accounts.integration.pagination.totalPages"));


	useEffect(() => {
    dispatch(fetchAccountIntegrations({ id, page, limit})); 
  }, [id, page]);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const INTEGRATION_TYPE_LABELS = {
    ms_dynamics_v2: "microsoft dynamics",
    ms_dynamics: "microsoft dynamics",
    zoho_v2: "zoho",
    salesforce_v2: "salesforce",
    google_analytics: "google analytics",
    google_analytics_4: "google analytics",
    google_tag_manager: "google tag manager",
    six_sense: "six sense",
    external_script: "external script",
  };

	return (
    <>
      <InfiniteScroll
        loading={isIntegrationsLoading}
        currentPage={currentPage}
        totalPages={totalPages}
        pagination={true}
        setPage={setPage}

      >
        <Table singleLine className={cx(styles.table)}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                INTEGRATION
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                CREATED BY
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                CREATED DATE
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                MODIFIED DATE
              </Table.HeaderCell>
              <Table.HeaderCell width={3} className={cx(styles.header)}>
                STATUS
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body className={cx(styles.body)}>
            {isIntegrationsLoading && _.size(integratedAccounts) === 0 && (
              <>
                <Table.Row>
                  <Table.Cell colSpan="5" className={cx(styles.cell)}>
                    <div className={cx(styles.noData)}>
                      Loading
                      <Icon name="sync" loading className={cx(styles.icon)} />
                    </div>
                  </Table.Cell>
                </Table.Row>
              </>
            )}
            {!isIntegrationsLoading && _.size(integratedAccounts) === 0 && (
              <>
                <Table.Row>
                  <Table.Cell colSpan="5" className={cx(styles.cell)}>
                    <div className={cx(styles.noData)}>
                      No Data
                    </div>
                  </Table.Cell>
                </Table.Row>
              </>
            )}

            {_.size(integratedAccounts) > 0 && (
              <>
                {integratedAccounts.map((item, idx) => (
                  <>
                    <Table.Row key={idx}>
                      <Table.Cell width={4} className={cx(styles.cell)}>
                        <div className={cx(styles.text, styles.name)}>
                          {_.get(INTEGRATION_TYPE_LABELS, item.type, item.type)}
                        </div>
                      </Table.Cell>
                      <Table.Cell width={4} className={cx(styles.cell)}>
                        <div className={cx(styles.text)}>
                          {_.get(item, 'createdBy.email', '')}
                        </div>
                      </Table.Cell>
                      <Table.Cell width={3} className={cx(styles.cell)}>
                        <div className={cx(styles.text)}>
                          {formatDate(_.get(item, 'createdDate'))}
                        </div>
                      </Table.Cell>
                      <Table.Cell width={3} className={cx(styles.cell)}>
                        <div className={cx(styles.text)}>
                          {formatDate(_.get(item, 'modifiedDate'))}
                        </div>
                      </Table.Cell>
                      <Table.Cell width={2} className={cx(styles.cell)}>
                        {
                          <div className={cx( styles.text, styles.status,
                            {[styles.error]: _.get(item, 'state.code') === 'auth_error'})}
                            >
                            <span className={styles.integrationStatus}>{_.get(item, 'state.code', '')}</span>
                            {_.get(item, 'state.code') === 'auth_error' && (
                              <div className={styles.emailSent}>
                                Sent on {item.lastExpiryEmailSent ? formatDate((_.get(item, 'lastExpiryEmailSent'))) : "N/A"}
                              </div>
                              )}
                          </div>
                        }
                      </Table.Cell>
                    </Table.Row>
                  </>
                ))}
              </>
            )}
          </Table.Body>
        </Table>
      </InfiniteScroll>
    </>
  );
}